import(/* webpackMode: "eager", webpackExports: ["NotificationPanelCustomizerWrapper"] */ "/builds/frontend/nx-frontend/libs/features/notification-panel/src/lib/notification-panel/notification-panel-customizer-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotificationPanelWrapper"] */ "/builds/frontend/nx-frontend/libs/features/notification-panel/src/lib/notification-panel/notification-panel-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotificationPanel"] */ "/builds/frontend/nx-frontend/libs/features/notification-panel/src/lib/notification-panel/notification-panel.tsx");
;
import(/* webpackMode: "eager" */ "/builds/frontend/nx-frontend/libs/pages/portal-client/src/lib/shared/reduxDevToolsAdapter.tsx");
;
import(/* webpackMode: "eager" */ "/builds/frontend/nx-frontend/libs/pages/portal-customizer/src/lib/styles/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AllPages"] */ "/builds/frontend/nx-frontend/libs/pages/webnotes-client/src/lib/widgets/all-pages/all-pages.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppMarketingHandler"] */ "/builds/frontend/nx-frontend/libs/pages/webnotes-client/src/lib/widgets/app-marketing-handler/app-marketing-handler.tsx");
;
import(/* webpackMode: "eager" */ "/builds/frontend/nx-frontend/libs/pages/webnotes-client/src/lib/widgets/app-socket-events/app-socket-events.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppWindowEvents"] */ "/builds/frontend/nx-frontend/libs/pages/webnotes-client/src/lib/widgets/app-window-events/app-window-events.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ChatWithWebComponent"] */ "/builds/frontend/nx-frontend/libs/pages/webnotes-client/src/lib/widgets/chat/chat-with-web-component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Chat"] */ "/builds/frontend/nx-frontend/libs/pages/webnotes-client/src/lib/widgets/chat/chat.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DuplicateFolderProgress"] */ "/builds/frontend/nx-frontend/libs/pages/webnotes-client/src/lib/widgets/folder/duplicate-folder-progress.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Folder"] */ "/builds/frontend/nx-frontend/libs/pages/webnotes-client/src/lib/widgets/folder/folder.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Guidegen"] */ "/builds/frontend/nx-frontend/libs/pages/webnotes-client/src/lib/widgets/guidegen/guidegen.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NoteTopbar"] */ "/builds/frontend/nx-frontend/libs/pages/webnotes-client/src/lib/widgets/note-topbar/note-topbar.tsx");
;
import(/* webpackMode: "eager" */ "/builds/frontend/nx-frontend/libs/pages/webnotes-client/src/lib/widgets/note/note-title.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Note"] */ "/builds/frontend/nx-frontend/libs/pages/webnotes-client/src/lib/widgets/note/note.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotesByTag"] */ "/builds/frontend/nx-frontend/libs/pages/webnotes-client/src/lib/widgets/notes-by-tag/notes-by-tag.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Settings"] */ "/builds/frontend/nx-frontend/libs/pages/webnotes-client/src/lib/widgets/settings/settings.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["isDashboardBundleLoaded","Tasks"] */ "/builds/frontend/nx-frontend/libs/pages/webnotes-client/src/lib/widgets/tasks/tasks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrialWrapper"] */ "/builds/frontend/nx-frontend/libs/pages/webnotes-client/src/lib/widgets/trial/trial-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EmojiSelector"] */ "/builds/frontend/nx-frontend/libs/shared/components/src/lib/image-selector/emoji-selector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EmojiView"] */ "/builds/frontend/nx-frontend/libs/shared/components/src/lib/image-selector/emoji-view.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useGetImage"] */ "/builds/frontend/nx-frontend/libs/shared/components/src/lib/image-selector/get-image.ts");
;
import(/* webpackMode: "eager", webpackExports: ["IconSelector"] */ "/builds/frontend/nx-frontend/libs/shared/components/src/lib/image-selector/icon-selector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageSelector"] */ "/builds/frontend/nx-frontend/libs/shared/components/src/lib/image-selector/image-selector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageView"] */ "/builds/frontend/nx-frontend/libs/shared/components/src/lib/image-selector/image-view.tsx");
;
import(/* webpackMode: "eager" */ "/builds/frontend/nx-frontend/libs/shared/components/src/lib/link/link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileBlocked"] */ "/builds/frontend/nx-frontend/libs/shared/components/src/lib/mobile-blocked/mobile-blocked.tsx");
;
import(/* webpackMode: "eager" */ "/builds/frontend/nx-frontend/libs/shared/components/src/lib/no-page-access-error-page/no-page-access-error-page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NoteBreadcrumbs"] */ "/builds/frontend/nx-frontend/libs/shared/components/src/lib/note-breadcrumbs/note-breadcrumbs.tsx");
;
import(/* webpackMode: "eager" */ "/builds/frontend/nx-frontend/libs/shared/components/src/lib/theme-selector/themes-list.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SocketProvider","SocketContext"] */ "/builds/frontend/nx-frontend/libs/shared/providers/src/lib/socket-provider.tsx");
;
import(/* webpackMode: "eager" */ "/builds/frontend/nx-frontend/libs/shared/ui/src/lib/checkbox/checkbox.tsx");
;
import(/* webpackMode: "eager" */ "/builds/frontend/nx-frontend/libs/shared/ui/src/lib/context-menu/context-menu-item-switch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContextMenuItem"] */ "/builds/frontend/nx-frontend/libs/shared/ui/src/lib/context-menu/context-menu-item.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContextMenuLayout"] */ "/builds/frontend/nx-frontend/libs/shared/ui/src/lib/context-menu/context-menu-layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContextMenuPopperWrapper"] */ "/builds/frontend/nx-frontend/libs/shared/ui/src/lib/context-menu/context-menu-popper-wrapper.tsx");
;
import(/* webpackMode: "eager" */ "/builds/frontend/nx-frontend/libs/shared/ui/src/lib/context-menu/context-menu.css");
;
import(/* webpackMode: "eager" */ "/builds/frontend/nx-frontend/libs/shared/ui/src/lib/icon/icon.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["MobileDeviceChecker","detectMobileDevice"] */ "/builds/frontend/nx-frontend/libs/shared/ui/src/lib/mobile-device-checker/mobile-device-checker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ModalLayout"] */ "/builds/frontend/nx-frontend/libs/shared/ui/src/lib/modal/modal-layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UiModalContent","ModalWrapper"] */ "/builds/frontend/nx-frontend/libs/shared/ui/src/lib/modal/modal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavbarButton"] */ "/builds/frontend/nx-frontend/libs/widgets/navbar/src/lib/navbar-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavbarWrapper"] */ "/builds/frontend/nx-frontend/libs/widgets/navbar/src/lib/navbar-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/builds/frontend/nx-frontend/libs/widgets/navbar/src/lib/navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useOpenKitchenMenuContextFolder"] */ "/builds/frontend/nx-frontend/libs/widgets/sidebar/src/lib/hooks/kitchen/open-menu-context-folder.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useOpenKitchenMenuContextNote"] */ "/builds/frontend/nx-frontend/libs/widgets/sidebar/src/lib/hooks/kitchen/open-menu-context-note.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useExpandOnFirstLoad"] */ "/builds/frontend/nx-frontend/libs/widgets/sidebar/src/lib/hooks/use-expand-on-first-load.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useSelectCurrentItem"] */ "/builds/frontend/nx-frontend/libs/widgets/sidebar/src/lib/hooks/use-select-current-item.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useSocket"] */ "/builds/frontend/nx-frontend/libs/widgets/sidebar/src/lib/hooks/use-socket.ts");
;
import(/* webpackMode: "eager", webpackExports: ["Sidebar"] */ "/builds/frontend/nx-frontend/libs/widgets/sidebar/src/lib/sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EffectorNext"] */ "/builds/frontend/nx-frontend/node_modules/@effector/next/dist/index.js");
;
import(/* webpackMode: "eager" */ "/builds/frontend/nx-frontend/node_modules/@unleash/nextjs/dist/FlagProvider.js");
;
import(/* webpackMode: "eager" */ "/builds/frontend/nx-frontend/node_modules/@unleash/nextjs/dist/hooks.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/frontend/nx-frontend/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/builds/frontend/nx-frontend/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/builds/frontend/nx-frontend/node_modules/next/dist/client/script.js");
